import api from './api';

export interface TeacherNotification {
  id: number;
  teacher: number;
  recipient_type: 'student' | 'parent';
  student: number | null;
  parent: number | null;
  recipient_name: string | null;
  student_name: string | null;
  title: string;
  body: string;
  status: 'pending' | 'delivered' | 'clicked' | 'ignored' | 'failed';
  created_at: string;
  delivered_at: string | null;
  clicked_at: string | null;
  first_app_open_at: string | null;
}

export interface SendNotificationData {
  recipient_type: 'student' | 'parent';
  student: number;
  parent?: number;
  title: string;
  body: string;
}

class NotificationService {
  async getByStudent(studentId: number): Promise<TeacherNotification[]> {
    const response = await api.get<TeacherNotification[]>('/notifications/', {
      params: { student: studentId },
    });
    return response.data;
  }

  async send(data: SendNotificationData): Promise<TeacherNotification> {
    const response = await api.post<TeacherNotification>('/notifications/', data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/notifications/${id}/`);
  }
}

const notificationService = new NotificationService();
export default notificationService;
